import text from './text';

export default {
  label: {
    ...text.small.regular,
    margin: '0.8em 0',
    input: {
      ...text.medium.bold,
      margin: '0.8em 0'
    }
  },
  checkboxLabel: {
    ...text.medium.regular
  },
  checkbox: {
    color: 'sky.base',
    'input:checked ~ &': {
      color: 'primary'
    }
  },
  switchLabel: {
    ...text.medium.bold,
    inactive: { ...text.medium.bold, color: 'sky.dark' }
  },
  select: {
    height: '60px',
    border: '1px solid rgba(0,0,0,0.1)',
    borderRadius: 'input',
    padding: '8px 15px',
    '&:disabled': {
      opacity: 0.5
    }
  },
  option: {
    bg: 'black'
  },
  input: {
    primary: {
      ...text.medium.regular,
      bg: 'transparent',
      padding: '12px 16px',
      border: '1px solid #D5D7DD',
      borderRadius: 'input',
      '&:focus': {
        outline: 'none',
        borderColor: 'primary'
      },
      '&::placeholder': {
        color: 'placeholder'
      }
    }
  },
  switch: {
    backgroundColor: 'placeholder',
    'input:checked ~ &': {
      backgroundColor: 'secondary'
    }
  }
};
